import { render, staticRenderFns } from "./DesempenoUser.vue?vue&type=template&id=2c0ceb15&scoped=true&"
import script from "./DesempenoUser.vue?vue&type=script&lang=js&"
export * from "./DesempenoUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0ceb15",
  null
  
)

export default component.exports